import _defineProperty from "/Users/jbijster/Documents/Projects/VVerduurzamen/Willem/willem.vverduurzamen.nl/willem-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import { List } from 'immutable';
/**
 * Generate metatags for an entity based on drupal metatag values.
 * Fallback document title to the node title.
 *
 * @param {Object} entity The entity for which to generate metatags
 * @return {Array} Return meta and title tags.
 */

export var generateMetaTagsFromEntity = function generateMetaTagsFromEntity(entity) {
  var results = [];
  var metatags = entity.getIn(['metatag', 'value'], List()); // Apply all metatags defined in metatag module.

  metatags.forEach(function (item, key) {
    if (item.get('tag') === 'title') {
      results = results.concat(
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("title", _extends({
        key: key
      }, item.get('attributes').deleteIn(['content']).toJS()), item.getIn(['attributes', 'content'])));
    } else {
      results = results.concat( /*#__PURE__*/React.createElement(item.get('tag'), _objectSpread({}, item.get('attributes').toJS())));
    }
  });
  return results;
};